import React from "react";
import { Control, FieldErrors } from "react-hook-form";
import GlobalPageSortFields from "../form/GlobalPageSortFields";
import { useTranslations } from "next-intl";

type TGlobalPageSortSidebarPops = {
  control: Control;
  errors: FieldErrors;
};

const GlobalPageSortSidebar = ({
  control,
  errors,
}: TGlobalPageSortSidebarPops) => {
  const t = useTranslations();

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold">{t("Sort Content")}</h3>
      <GlobalPageSortFields control={control} errors={errors} />
    </div>
  );
};

export default GlobalPageSortSidebar;
